function DroneImageOverlay(bounds, imageSrc, map, imageCornerCoordinates, rotation, upper_left, label) {

  // Initialize all properties.
  this.bounds_ = bounds;
  this.image_ = imageSrc;
  this.map_ = map;

  // Define a property to hold the image's div. We'll
  // actually create this div upon receipt of the onAdd()
  // method so we'll leave it null for now.
  this.div_ = null;
  this.imageCoordinates = imageCornerCoordinates
  // Explicitly call setMap on this overlay.
  this.setMap(map);
  this.rotation = rotation
  this.projWidth = null
  this.projHeight = null
  this.divWidth = null
  this.divHeight = null
  this.widthDiffPercentage = null
  this.heightDiffPercentage = null
  this.upperLeft = upper_left
  this.onClick = null
  this.label = label
}

/**
 * onAdd is called when the map's panes are ready and the overlay has been
 * added to the map.
 */
export function initializeDroneImageOverlay(){
  DroneImageOverlay.prototype = new google.maps.OverlayView();

  DroneImageOverlay.prototype.onAdd = function() {
    var div = document.createElement('div');
    div.style.borderStyle = 'none';
    div.style.borderWidth = '0px';
    div.style.position = 'absolute';
    div.style.zIndex = '9999';
    // document.getElementById('overlayslider').addEventListener("input", function() {
    //   div.style.transform = 'rotate(' + this.value + 'deg)';
    // });
    div.style.transform = 'rotate(' + this.rotation + 'deg)'
    // Create the img element and attach it to the div.
    var img = document.createElement('img');
    img.src = this.image_;
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.position = 'absolute';
    img.style.zIndex = '9999';
    div.appendChild(img);
    div.innerHTML+=`<figcaption style='text-align: center;'> ${this.label || ''} </figcaption>`

    this.div_ = div;

    // Add the element to the "overlayLayer" pane.
    var panes = this.getPanes();
    // panes.overlayLayer.appendChild(div);
    if(this.onClick){
      panes.overlayMouseTarget.appendChild(div);
      var overlay = this
      google.maps.event.addDomListener(this.div_, 'click', function() {
        event.stopPropagation()
        overlay.onClick(overlay)
      });
    } else {
      panes.overlayLayer.appendChild(div);
    }
  };

  DroneImageOverlay.prototype.draw = function() {
    // We use the south-west and north-east
    // coordinates of the overlay to peg it to the correct position and size.
    // To do this, we need to retrieve the projection from the overlay.
    var overlayProjection = this.getProjection();

    // Retrieve the south-west and north-east coordinates of this overlay
    // in LatLngs and convert them to pixel coordinates.
    // We'll use these coordinates to resize the div.
    var sw = overlayProjection.fromLatLngToDivPixel(this.bounds_.getSouthWest());
    var ne = overlayProjection.fromLatLngToDivPixel(this.bounds_.getNorthEast());
    var imageCoordPixel1 = overlayProjection.fromLatLngToDivPixel(
      new google.maps.LatLng(this.imageCoordinates[0].lat, this.imageCoordinates[0].lng)
    );
    var imageCoordPixel2 = overlayProjection.fromLatLngToDivPixel(
      new google.maps.LatLng(this.imageCoordinates[1].lat, this.imageCoordinates[1].lng)
    );
    var imageCoordPixel3 = overlayProjection.fromLatLngToDivPixel(
      new google.maps.LatLng(this.imageCoordinates[2].lat, this.imageCoordinates[2].lng)
    );

    var dist1 = Math.sqrt(Math.pow((imageCoordPixel1.x - imageCoordPixel2.x), 2) + Math.pow((imageCoordPixel1.y - imageCoordPixel2.y), 2))
    var dist2 = Math.sqrt(Math.pow((imageCoordPixel3.x - imageCoordPixel2.x), 2) + Math.pow((imageCoordPixel3.y - imageCoordPixel2.y), 2))
    // Resize the image's div to fit the indicated dimensions.
    // var div = this.div_;
    // div.style.left = sw.x + 'px';
    // div.style.top = ne.y + 'px';
    // div.style.width = (ne.x - sw.x) + 'px';
    // div.style.height = (sw.y - ne.y) + 'px';
    var div = this.div_;
    var top_left = sw.x;
    var top_top = ne.y;
    var main_width = (ne.x - sw.x);
    var main_height = (sw.y - ne.y);
    var projWidth = ((dist1 > dist2) ? dist1 : dist2)
    var projHeight = ((dist1 > dist2) ? dist2 : dist1)
    var widthDelta = (main_width - projWidth)/2
    var heightDelta = (main_height - projHeight)/2
    this.widthDelta = widthDelta
    this.heightDelta = heightDelta
    this.divWidth = projWidth
    this.divHeight = projHeight
    if(this.widthDiffPercentage){
      projWidth = (projWidth * this.widthDiffPercentage)/100
      projHeight = (projHeight * this.heightDiffPercentage)/100
    }
    div.style.left = (sw.x + widthDelta) + 'px';
    div.style.top = (ne.y + heightDelta) + 'px';
    div.style.width = projWidth + 'px';
    div.style.height = projHeight + 'px';
    var figCap = div.children[1]
    figCap.style.marginTop = parseFloat(projHeight) + 'px'
    figCap.style.fontSize = parseInt(main_width)/3 + 'px'
  };

  // The onRemove() method will be called automatically from the API if
  // we ever set the overlay's map property to 'null'.
  DroneImageOverlay.prototype.onRemove = function() {
    this.div_.parentNode.removeChild(this.div_);
    this.div_ = null;
  };
  return DroneImageOverlay
}